var map = {
	"./app/version/index.vue": 895,
	"./consent-form/index.vue": 2612,
	"./content/agreement/index.vue": 8633,
	"./coupon/detail.vue": 984,
	"./coupon/edit.vue": 546,
	"./coupon/index.vue": 1600,
	"./coupon/issue.vue": 5184,
	"./coupon/records.vue": 6112,
	"./dashboard/index.vue": 7490,
	"./error/404.vue": 6865,
	"./login/index.vue": 4353,
	"./member/index.vue": 5753,
	"./member/message/index.vue": 8396,
	"./order/order-contact/index.vue": 4465,
	"./order/product/detail.vue": 1083,
	"./order/product/index.vue": 9434,
	"./order/service/detail.vue": 987,
	"./order/service/index.vue": 4175,
	"./partner/detail.vue": 7531,
	"./partner/index.vue": 6449,
	"./product/detail.vue": 625,
	"./product/edit.vue": 1653,
	"./product/index.vue": 330,
	"./profile/index.vue": 7452,
	"./redirect/index.vue": 3849,
	"./reminder/index.vue": 6944,
	"./sale/order/index.vue": 9294,
	"./sale/package/index.vue": 201,
	"./system/agreement/index.vue": 4399,
	"./system/config/index.vue": 7744,
	"./system/dict/index.vue": 47,
	"./system/menu/index.vue": 1967,
	"./system/operation-log/index.vue": 6804,
	"./system/role/index.vue": 1778,
	"./system/user/index.vue": 5555
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9464;